/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "customer-discount-groups-management-component",
	props: ["companyId", "activeOrInactiveKey", "searchQuery", "filterStateChanged", "showLinkingModal", "showTableActions", "companyName"],
	emits: ["linkingModalClose"],
	data() {
		return {
			customerDiscountGroups: [],
			customerDiscountGroupsHeadings: [
				{
					text: "Name",
					field: "name"
				},
				{
					text: "Discount Amount",
					field: "discountAmountAsString"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
            productsToLinkHeadings:[
                {
                    text: "Product",
                    field: "product"
                },
                // {
                // 	text: "Original Price",
                // 	field: "priceAsString"
                // },
                {
                    text: "Discount Amount",
                    field: "discountAmountAsString"
                },
                // {
                // 	text: "Price After Discount",
                // 	field: "priceAfterDiscountAsString"
                // }
            ],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actionKeys:{
				view: "view",
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				linkProducts: "linkProducts",
				linkCustomers: "linkCustomers"
			},
			linkAndUnlinkDiscountGroupModal:{
				showModal: false,
				isSaving: false,
				modalId: "linkAndUnlinkDiscountGroupModal",
				heading: "Link And Unlink Discount Group From Customer",
				isActive: null,
				companyId: null
			},
			customerDiscountUnlinkCustomerModal:{
				showModal: false,
				isSaving: false,
				modalId: "unlinkCustomerDiscountGroupModal",
				heading: "Unlink Customer From Discount Group?",
				message: "Unlinking a customer from a discount group will remove the customer's discount. Are you sure you want to unlink this customer?",
				customerDiscountGroupId: null
			},
			customerDiscountGroupAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditCustomerDiscountGroupModal",
				heading: "Add Customer Discount Group",
				customerDiscountGroup:{
					customerDiscountGroupId: null,
					isActive: true,
					name: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					discountAmount: {
						value: null,
						hasError: false,
						errorMessage: null
					}
				}
			},
			customerDiscountGroupMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markCustomerDiscountGroupAsActiveInactiveModal",
				heading: "Mark Customer Discount Group As Active/Inactive",
				isActive: null,
				customerDiscountGroupId: null
			},
			linkProductsToDiscountGroupModal: {
				showModal: false,
				isSaving: false,
				modalId: "linkProductsToDiscountGroupModal",
				heading: "Link Products To Discount Group",
				customerDiscountGroupId: null
			},
            customerDiscountGroupAddEditForm:{
                customerDiscountGroup:{
                    customerDiscountGroupId: null,
                    isActive: true,
                    name: {
                        value: null,
                        hasError: false,
                        errorMessage: null
                    },
                    discountAmount: {
                        value: null,
                        hasError: false,
                        errorMessage: null
                    },
                    linkedProducts:{
                        value: [],
                        hasError: false,
                        errorMessage: null
                    },
                    unlinkedProducts:{
                        value: [],
                        hasError: false,
                        errorMessage: null
                    },
                }
            },
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			loading: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			tableHasActions: true
		};
	},
	methods: {
		getCustomerDiscountGroups() {
			this.loading = true;
			let request ={
				searchQuery: this.searchQuery,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				isActive: castingUtility.toBoolean(this.activeOrInactiveKey),
				//companyId: this.companyId
			};
			orderService.getDiscountGroups(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customerDiscountGroups = successResponse.data.result;
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						for(let i = 0; i < this.customerDiscountGroups.length; i++) {
							this.customerDiscountGroups[i].actions = [
								{
									name: "View",
									key: this.actionKeys.view,
									elementId: "btnViewCustomerDiscountGroup"
								}
							];
							this.customerDiscountGroups[i].discountAmountAsString = currencyHelper.numberToCurrency(this.customerDiscountGroups[i].discountAmount);
						}
						this.customerDiscountGroups = dataTableHelper.castFieldValues(this.customerDiscountGroups);
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
        getProductsForDiscountGroup(){
            orderService.getProductsForDiscountGroup(this.customerDiscountGroupAddEditForm.customerDiscountGroup.customerDiscountGroupId).then(
                successResponse => {
                    let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
                    if(isSuccess){
                        this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value = successResponse.data.result;
                        for(let i = 0; i < this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value.length; i++){
                            this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value[i].discountAmountAsString = currencyHelper.numberToCurrency(this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value[i].discountAmount);
                        }
                    }
                },
                errorResponse => {
                    console.log("error", errorResponse);
                    this.loading = false;
                    apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
                }
            );
        },
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			//TODO: filter customer results
			this.getCustomerDiscountGroups();
		},
		// onActiveInactiveFilterSelected(activeOrInactiveKey){
		// 	this.filter.activeOrInactiveItems = activeOrInactiveKey;
		// 	this.filterStateChanged = true;
		// 	console.log("filter", this.filter);
		// },
		onAddCustomerDiscountGroupClick(){
			this.customerDiscountGroupAddEditFormModal.heading = "Add Customer Discount Group";
			this.clearCustomerDiscountGroupModel();
			this.customerDiscountGroupAddEditFormModal.showModal = true;
		},
		onCustomerDiscountGroupActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
                case this.actionKeys.view:
					$("#viewDiscountGroupModal").modal("show");
                    this.customerDiscountGroupAddEditForm.customerDiscountGroup.customerDiscountGroupId = actionAndData.data.discountGroupId;
                    this.customerDiscountGroupAddEditForm.customerDiscountGroup.name.value = actionAndData.data.name;
                    this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value = actionAndData.data.discountAmount;
                    this.getProductsForDiscountGroup();
					break;
			}
		},
        onViewDiscountGroupModalClose(){
            $("#viewDiscountGroupModal").modal("hide");
            this.customerDiscountGroupAddEditForm.customerDiscountGroup = {
                customerDiscountGroupId: null,
                isActive: true,
                name: {
                    value: null,
                    hasError: false,
                    errorMessage: null
                },
                discountAmount: {
                    value: null,
                    hasError: false,
                    errorMessage: null
                },
                linkedProducts:{
                    value: [],
                    hasError: false,
                    errorMessage: null
                },
                unlinkedProducts:{
                    value: [],
                    hasError: false,
                    errorMessage: null
                },
            };
        },
		// onConfirmUnlinkClick(confirm){
		// 	if(confirm){
		// 		this.unlinkCustomerFromDiscountGroup();
		// 	}
		// 	else{
		// 		this.customerDiscountUnlinkCustomerModal.showModal = false;
		// 	}
		// },
		// unlinkCustomerFromDiscountGroup(){
		// 	this.customerDiscountUnlinkCustomerModal.isSaving = true;
		// 	let request = {
		// 		discountGroupId: this.customerDiscountUnlinkCustomerModal.customerDiscountGroupId,
		// 		companyIdsToLink: [],
		// 		companyIdsToUnlink: [this.companyId]
		// 	};
		// 	orderService.linkAndUnlinkCompaniesFromDiscountGroup(request).then(
		// 		successResponse => {
		// 			let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
		// 			if(isSuccess){
		// 				this.showSuccessMessage = true;
		// 				this.successMessage = "Customer unlink was successful";
		// 				this.getCustomerDiscountGroups();
		// 			}
		// 			else{
		// 				this.showErrorMessage = true;
		// 				this.errorMessage = successResponse.data.message;
		// 			}
		// 			this.customerDiscountUnlinkCustomerModal.isSaving = false;
		// 			this.customerDiscountUnlinkCustomerModal.showModal = false;
		// 		},
		// 		errorResponse => {
		// 			console.log("error", errorResponse);
		// 			this.customerDiscountUnlinkCustomerModal.isSaving = false;
		// 			this.customerDiscountUnlinkCustomerModal.showModal = false;
		// 			apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
		// 		}
		// 	);
		// },
		clearCustomerDiscountGroupModel(){
			this.customerDiscountGroupAddEditFormModal.customerDiscountGroup = {
				customerDiscountGroupId: null,
				isActive: true,
				name: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				discountAmount: {
					value: null,
					hasError: false,
					errorMessage: null
				}
			}
		},
		// onLinkingSave(isSuccess){
		// 	if(isSuccess){
		// 		this.getCustomerDiscountGroups();
		// 	}
		// 	else{
		// 		this.showErrorMessage = true;
		// 		this.errorMessage = "Error occurred while linking discount groups to customer";
		// 	}
		// 	this.linkAndUnlinkDiscountGroupModal.showModal = false;
		// 	this.$emit("linkingModalClose", true);
		// },
		onSuccessModalOkClick(){
			this.showSuccessMessage = false;
		},
		onErrorModalOkClick(){
			this.showErrorMessage = false;
		},
		onLinkAndUnlinkClick(){
			this.linkAndUnlinkDiscountGroupModal.showModal = true;
			this.linkProductsToDiscountGroupModal.companyId = this.companyId;
		},
		onLinkAndUnlinkModalClose(){
			this.linkAndUnlinkDiscountGroupModal.showModal = false;
			this.$emit("linkingModalClose", true);
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Discount Groups - " + this.companyName);
			var breadcrumbs = [];
			var breadcrumbLogistics = {
				url: null,
				displayText: "Pricing"
			};
			var driverManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Discount Groups"
			};
			breadcrumbs.push(breadcrumbLogistics);
			breadcrumbs.push(driverManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		//this.setBreadcrumbs();
		//this.getCustomerDiscountGroups();
	},
	watch:{
		// companyId: {
		// 	handler: function () {
		// 		if(this.companyId !== null && this.companyId > 0){
		// 			this.getCustomerDiscountGroups();
		// 		}
		// 	},
		// 	immediate: true,
		// 	deep: true
		// },
		filterStateChanged:{
			handler: function () {
				if(!this.filterStateChanged){
					// if(this.companyId !== null && this.companyId > 0){
					// 	this.getCustomerDiscountGroups();
					// }
                    this.getCustomerDiscountGroups();
				}
			},
			immediate: true,
			deep: true
		},
		showLinkingModal:{
			handler: function () {
				if(this.showLinkingModal){
					this.onLinkAndUnlinkClick();
				}
			},
			immediate: true,
			deep: true
		},
		showTableActions:{
			handler: function () {
				this.tableHasActions = this.showTableActions;
			},
			immediate: true,
			deep: true
		},
		companyName:{
			handler: function () {
				this.setBreadcrumbs();
			},
			immediate: true,
			deep: true
		}
	}
};